/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import { ISignUpUserMethods, SignUpUserService } from "./components";

export type SignUpPageAgent = ISignUpUserMethods;

const getPlugins = () => {
  return [new SignUpUserService()];
};

export const getAgent = () => {
  return createAgent<SignUpPageAgent>({
    plugins: getPlugins(),
  });
};
